const t = "@perxis-auto/trade-in-instock", a = {
  name: t
};
export {
  a as default,
  t as name
};
